import React, { useState } from 'react'
import { usePopper } from 'react-popper';

export default function InfoPopperElement({ 
    text = 'This is a example info text', 
    title = "Popper title"
}) {
    const [referenceElement, setReferenceElement] = useState(null)
    const [popperElement, setPopperElement] = useState(null)
    const [arrowElement, setArrowElement] = useState(null)
    const { styles, attributes } = usePopper(referenceElement, popperElement, {
        modifiers: [{ 
            name: 'arrow', 
            options: { element: arrowElement } 
        }]
    })

    const [isActive, setActive] = useState(false)

    return (
        <>
            <svg
                onMouseOver={() => setActive(true)}
                onMouseLeave={() => setActive(false)}
                onClick={() => setActive(!isActive)}
                ref={setReferenceElement}
                className="w-[20px] h-[20px] opacity-100 shrink-0"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="#cccccc">
                <path strokeLinecap="round" strokeLinejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z">
                </path>
            </svg>

            {isActive && (
                <div className='select-none opacity-100 z-10 bg-white shadow rounded-[12px] py-[7px] px-[9px] whitespace-normal min-w-[210px] max-w-[210px] flex flex-col' ref={setPopperElement} style={styles.popper} {...attributes.popper}>
                    <div className='font-bold text-[#0B0B0B] text-[12px] max-w-[200px]'>{title}</div>
                    <div className='text-[12px] max-w-[200px] font-[400]'>{text}</div> 
                    <div ref={setArrowElement} style={styles.arrow} />
                </div>
            )}
        </>
    )
}